let cached: boolean | null = null;

function tryContext(attrs: WebGLContextAttributes): boolean {
  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl2", attrs) ||
      canvas.getContext("webgl", attrs) ||
      canvas.getContext("experimental-webgl", attrs);
    if (!gl) return false;
    // Confirm we can actually read driver info (broken contexts throw here).
    const ctx = gl as WebGLRenderingContext;
    return !!ctx.getParameter(ctx.VERSION);
  } catch {
    return false;
  }
}

/**
 * True if the browser can run Mapbox GL. We prefer *hardware* WebGL
 * (`failIfMajorPerformanceCaveat`), but if only a software renderer is available
 * (SwiftShader / llvmpipe / remote-desktop GL) we still allow Mapbox rather than
 * suppressing it — the `MapFallbackBoundary` + `onFatal` in MapView transparently
 * drop to the SVG map if Mapbox actually crashes. This keeps the Mapbox map
 * available wherever a token is configured, without ever breaking the fallback.
 */
export function webglAvailable(): boolean {
  if (cached !== null) return cached;
  cached =
    tryContext({ failIfMajorPerformanceCaveat: true }) || // hardware GL, preferred
    tryContext({}); // software/less-capable GL — Mapbox may still work; boundary guards
  return cached;
}
